import { render, staticRenderFns } from "./movePlanModal.vue?vue&type=template&id=28527e36&scoped=true"
import script from "./movePlanModal.vue?vue&type=script&lang=js"
export * from "./movePlanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28527e36",
  null
  
)

export default component.exports